import { HttpClient } from '@angular/common/http';
import { Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, NavigationEnd } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { PermissionConstants } from '../../models/const.PermissionConstants';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { CommonDataResolver } from '../_infrastructure/CommonData/CommonDataResolver';
import { CommonDataService } from '../_infrastructure/CommonData/CommonDataService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { ExternalValidationsService } from '../_infrastructure/ValidationMessages/ExternalValidationsService';
import { DynamicCardsRegister } from './DynamicCardsRegister';
import { ICardComponent } from './ICardComponent';
import { WorkflowComponentNew } from './workflow-new.component';
import { LogType } from '../../models/const.LogModelVM';


@Component({
  selector: 'workflow-step-new',
  templateUrl: './step-new.component.html',
  standalone: false
})
export class StepComponentNew implements OnInit, OnDestroy {

  @ViewChild('cardContainer', { static: true, read: ViewContainerRef })
  protected entry: ViewContainerRef;
  public currentStepCode: string; // Recebido da rota
  public workflowId: string;

  public isStepLoaded: boolean = false;

  // Esta é a configuração do step, deve ser lida algures no início com base no currentStepCode
  // precisamos de saber para cada cartão o tipo de componente e o nome da propriedade do objeto stepData a que corresponde cada cardData
  public cards: models.CardVM[];
  public cardComponentRefs: ComponentRef<ICardComponent>[];

  private currentStepData: any = {};

  private navigationSubscription;

  // Quando alguém aceder a stepData colecionamos os dados dos vários cartões
  // o objeto devolvido para a configuração acima é:
  // {
  //     contacts1: dadosDoCartaoSubscriberContactsComponent
  //     identification: dadosDoCartaoSubscriberIdentificationComponent
  //     contacts2: dadosDoCartaoSubscriberContactsComponent
  // }
  public get stepData(): {} {
    const _stepData = this.currentStepData || {};
    this.cardComponentRefs.forEach((cardComponentRef, index) => {
      //_stepData[this.cards[index].cardDataPropertyName] = cardComponentRef.instance.cardData;
      _stepData[cardComponentRef.instance.cardConfiguration.cardCode] = cardComponentRef.instance.cardData;
    })

    var sCards = Object.keys(_stepData).join(";");
    var sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | get stepData | StepCode: ' + this.currentStepCode + ' | Cards: ' + sCards;
    this.parentWorkflow.writeToLog(sMessage, LogType.Debug);
    return _stepData;
  };
  // Quando alguém atualizar os dados do step atualizamos tb os dados dos vários cartões
  public set stepData(value: {}) {
    var sCards = "";
    if (value != undefined) { sCards = Object.keys(value).join(";"); }
    var sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | set stepData | StepCode: ' + this.currentStepCode + ' | Cards: ' + sCards;
    this.parentWorkflow.writeToLog(sMessage, LogType.Debug);

      this.currentStepData = value || {};
      const _stepData = value || {};

      this.cardComponentRefs.forEach((cardComponentRef, index) => {
        //cardComponentRef.instance.cardData = _stepData[this.cards[index].cardDataPropertyName] || {};
        cardComponentRef.instance.cardData = _stepData[cardComponentRef.instance.cardConfiguration.cardCode] || {};
      })
  };

  //Fast workfarround for PRD last package, might need to be changed later
  private get disableTableRemoveIcons() {
    return this.isWorkflowOnSubscriber ||
      !this.securityService.canUserSaveData() ||
      false; // TODO: Ver com o BE // this.parentWorkflow?.workflowInstance?.stateCode === "C";
  }

  private get isWorkflowOnSubscriber() {
    //Se for Atendimento envia sempre FALSE, pois este pode alterar independentemente de onde está o Pedido
    if (this.securityService.userDetails.informationGroups.includes("PGPA"))
      return false;
    else
      return !this.isWorkflowMandatory && this.securityService.userHasPermission(PermissionConstants.WorkflowEditPage.editSubscriberData)
  }

  private get isWorkflowIncapacity() {
    return false;
  //  return this.parentWorkflow.workflowInstance.workflowCode === "PEDI001F" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001G" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001H" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001I" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001J" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001K" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001U" ||
  //    this.parentWorkflow.workflowInstance.workflowCode === "PEDI001Y";
  }

  private get isWorkflowPgpv() {
    return !this.isWorkflowMandatory &&
      (this.securityService.isUserPgpv() || this.isWorkflowPgpt) &&
      true; // TODO: Ver com o BE //this.parentWorkflow?.workflowInstance?.stateCode === "C";
  }

  private get isWorkflowPgpt() {
    return this.securityService.isUserPgpt(); // && this.parentWorkflow?.workflowInstance?.stateCode === "C";
  }

  private get isWorkflowMandatory() {
    return this.parentWorkflow.workflowTemplate.mandatory;
  }

  private get isWorkflowAgeLimit() {
    //Esta hardcoded mas deveria ser parametrizavel ou no Oracle (flag) ou numa lista do lado SQL
  //  return this.parentWorkflow.workflowInstance.workflowCode === "PEDI001E"
  //    || this.parentWorkflow.workflowInstance.workflowCode === "PEDI005E"
    //    || this.parentWorkflow.workflowInstance.workflowCode === "PEDI008E" ;
    return false;// TODO: Ver com o BE
  }

  constructor(
    // Este é o componente pai 'workFlow'
    private parentWorkflow: WorkflowComponentNew ,
    private http: HttpClient, private resolver: ComponentFactoryResolver,
    private activeRoute: ActivatedRoute, private commonDataService: CommonDataService,
    private alertService: AlertService, private securityService: SecurityService, private externalValidationService: ExternalValidationsService,
    private router : Router) {
    this.currentStepData = {};
    this.activeRoute.paramMap.subscribe((params: ParamMap) => {
      this.activeRoute.parent.params.subscribe((paramsP: ParamMap) => {
        this.currentStepCode = params.get('currentStepCode');
        this.workflowId = paramsP["workflowInstanceId"];

        var sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | Constructor -> loadStepAndCardInformation | StepCode: ' + this.currentStepCode ;
        this.parentWorkflow.writeToLog(sMessage, LogType.Debug);
        this.loadStepAndCardInformation();
      });
    });
    this.externalValidationService.errorsChangedSubject.subscribe(newErrors => { this.setExternalValidationErrors(newErrors)})
  }

  protected createCardComponents() {
    // Destruir os cardComponentRefs??
    // Bastará o entry.clear??
    this.entry?.clear();
    if (this.cardComponentRefs !== undefined) {
      //this.cardComponentRefs.forEach(c => c.destroy());
      this.cardComponentRefs = [];
    }

    // O forkJoin não emite se o array for vazio, ou seja temos que fazer esta validação e devolver o Observavel na mesma
    // https://github.com/ReactiveX/rxjs/issues/2816
    // Com este retorno mantemos a consistência nos métodos seguintes
    if (this.cards?.length === 0) {
      return of(this.cardComponentRefs = []);
    }

    return forkJoin(this.cards.map((card) => {
      const factoryClass = DynamicCardsRegister[card.cardComponent];
      if (factoryClass === undefined)
        throw "Tipo de cartão: " + card.cardComponent + " não encontrado, por favor preencha o registo DynamicCardsRegister no ficheiro DynamicCardsRegister.ts com o nome do componente e a correspondente classe";

      return CommonDataResolver.resolveCommonDataForComponent(factoryClass, this.commonDataService)
        .pipe(map(() => {
          const factory = this.resolver.resolveComponentFactory<ICardComponent>(factoryClass);
          return { factory, card };
        }));
    }))
      .pipe(map(factories => {

          // Guardamos a lista de componentes que criamos dinamicamente para ler os dados, atualizar os dados, e destruir quando for caso disso
        return this.cardComponentRefs = factories.map((factory) => {
          const componentRef = this.entry.createComponent<ICardComponent>(factory.factory);

          componentRef.instance.cardConfiguration = factory.card;
          componentRef.instance.isWorkflowOnSubscriber = this.isWorkflowOnSubscriber;
          componentRef.instance.isWorkflowPgpv = this.isWorkflowPgpv;
          componentRef.instance.isWorkflowPgpt = this.isWorkflowPgpt;
          componentRef.instance.disableTableRemoveIcons = this.disableTableRemoveIcons;
          componentRef.instance.isWorkflowMandatory = this.isWorkflowMandatory;
          componentRef.instance.isWorkflowAgeLimit = this.isWorkflowAgeLimit;
          componentRef.instance.parentWorkflow = this.parentWorkflow;
          componentRef.instance.isWorkflowIncapacity = this.isWorkflowIncapacity;

          return componentRef;
        });

      }));
  }

  public renavigateToRoot() {
    var sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | renavigateToRoot -> loadStepAndCardInformation | StepCode: ' + this.currentStepCode;
    this.parentWorkflow.writeToLog(sMessage, LogType.Debug);
    this.loadStepAndCardInformation();
  }

  private loadStepAndCardInformation() {
    this.cards = [];
    //console.log(`Seting card information for step: ${this.currentStepCode}`);

    return this.parentWorkflow.initialized.pipe(flatMap(() => {
      const stepDefinition = this.parentWorkflow.getStepDefinition(this.currentStepCode);

      // Não vamos validar se a rota bate certo com a definição de steps do workflow
      // Isso é um erro e como tal deve estoirar
      // Mesmo que validássemos nunca saberíamos resolver a situação, lançar alerta ao utilizador e depois?
      // A fazer alguma coisa será aqui a colocar o currentStepCode a undefined e depois o resto deve reagir a isso

      if (stepDefinition?.stepCode === "StepObs" && stepDefinition?.cards[0].cardCode !== "Observations")
        this.cards = stepDefinition?.cards.reverse();
      else
        this.cards = stepDefinition?.cards;
      // HACK _ UNTIL BE RETURN CORRECT
      if (!!this.cards && this.cards[0].cardCode == "Beneficiary") {
        this.cards[0].cardComponent = "BeneficiaryListComponent";
        this.cards[0].cardDataPropertyName = "BeneficiaryListComponent";
      }
      // END OFHACK _ UNTIL BE RETURN CORRECT
      return this.createCardComponents()
    }
    )).subscribe(() => {
      var sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | loadStepAndCardInformation -> getStepData (Call) | StepCode: ' + this.currentStepCode;
      this.parentWorkflow.writeToLog(sMessage, LogType.Debug);
      this.stepData = this.parentWorkflow.getStepData(this.currentStepCode);

      var sCards = Object.keys(this.stepData).join(";");
      sMessage = 'WorkFlow Instance: ' + this.parentWorkflow.workflowInstanceId + ' <-> ' + this.parentWorkflow.workflowCode + ' | StepComponent | loadStepAndCardInformation > getStepData (Response) | StepCode: ' + this.currentStepCode + ' | Cards: ' + sCards;
      this.parentWorkflow.writeToLog(sMessage, LogType.Debug);

      this.setExternalValidationErrors(this.externalValidationService.getCurrentErrors());
      this.parentWorkflow.activateStep(this);

      this.isStepLoaded = true;
      //console.log(`Data for step: ${this.currentStepCode}:`, this.stepData);

      return this.stepData;
    });
  }

  getWorkflowNeedsRevision(): models.SendWorkflowVM{
    const sendWorkFlowComponent = this.cardComponentRefs.find(card => !isNullOrUndefined(card.instance.getWorkflowNeedsRevision));
    return isNullOrUndefined(sendWorkFlowComponent) ? { revisionNeeded: false, revisionReason: null } : sendWorkFlowComponent.instance.getWorkflowNeedsRevision();
  }

  setExternalValidationErrors(errors: models.WorkflowValidationsVM) {
    var stepErrors = errors?.stepValidationsResult?.find(workflowErrors => workflowErrors.stepCode === this.currentStepCode)?.errors
    this.cardComponentRefs.forEach(card => {
      card.instance.cardExternalValidationErrors = stepErrors?.filter(error => error.cardCode === card.instance.cardConfiguration.cardCode);
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.entry.clear();
    if (this.cardComponentRefs !== undefined)
        //this.cardComponentRefs.forEach(c => c.destroy());
        this.cardComponentRefs = [];
  }
}
